
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Chevron extends Vue {
  @Prop({ required: true })
  down!: boolean;
}
